/**
 * @file industry.js
 * @desc 登陆平台信息
 * @author baibangyi
 */
'use strict';

export default {
    namespaced: true,
    state: {
        ind: {
            /* eslint-disable*/
            law: {
                logo: 'https://lvlin-base.cdn.bcebos.com/fe-saas/common/logo.png',
                miniLogo: 'https://lvlin-base.cdn.bcebos.com/fe-saas/common/logo-white.png',
                name: '律临',
                bg: 'https://midpf-mp-pub.cdn.bcebos.com/law-background.jpg',
                solgan: '',
                bgcolor: '#f9fafd',
                height: '100vh',
                product: 'lvlin'
            }
            /* eslint-enable*/

        }
    },
    mutations: {
    },
    actions: {
    }
};
